import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=c79a20c6"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports